import { z } from "zod";

export const azureDatabricksFormSchema = z
  .object({
    azure_tenant_id: z.string().optional().default(""),
    databricks_account_id: z.string().min(1, "Databricks Account ID is required"),
    workspace_url: z
      .string()
      .min(1, "Workspace URL is required")
      .url("Workspace URL must be a valid URL"),
    sp_client_id: z.string().optional().default(""),
    sp_secret: z.string().optional().default(""),
    sql_warehouse_id: z.string().min(1, "SQL Warehouse ID is required"),
    system_catalog_scope: z.enum(["all", "specific"]),
    system_catalog_schemas: z.string().optional().default(""),
  })
  .refine(
    data =>
      (data.azure_tenant_id ?? "").trim().length > 0 ||
      ((data.sp_client_id ?? "").trim().length > 0 && (data.sp_secret ?? "").trim().length > 0),
    {
      message:
        "Provide at least one: Azure Tenant ID, or Service Principal Client ID + Secret. You may also provide all three.",
      path: ["azure_tenant_id"],
    }
  )
  .refine(
    data =>
      data.system_catalog_scope === "all" || (data.system_catalog_schemas ?? "").trim().length > 0,
    {
      message: "List the specific schemas granted (e.g. billing, compute)",
      path: ["system_catalog_schemas"],
    }
  );

export type AzureDatabricksFormValues = z.infer<typeof azureDatabricksFormSchema>;
